import {Breadcrumb, ProgressIndicator, Modal} from '@/components/atoms';
import {PageHeader, SaveCancelFooter} from '@/components/molecules';
import {PageContainer} from '@/components/organisms';
import {ProductsPointMultiplierSection} from '@/pages/PointMultiplier/ProductsPointMultiplierSection';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '@/utils/constants/routesConstants';
import {useCreatePointMultiplier} from '@/pages/PointMultiplier/CreatePointMultiplier-hook';
import {usePointMultiplier} from '@/hooks/usePointMultiplier';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import {logger} from '@/helpers/logger';
export const ProductsPointMultiplier = () => {
  const navigate = useNavigate();
  const {
    formData,
    setFormData,
    formError,
    setFormError,
    rulesCriteriaJsonSchema,
    segmentJsonSchema,
    categoryJsonSchema,
    channelJsonSchema,
    rulesCriteriaUISchema,
    handleFormChange,
    disableNext,
    setDisableNext,
    formFields,
    handleUpdateValue,
    createReqObj,
    onClickPrimaryButton,
    onClickSecondaryButton,
    isCancel,
    handleCancel
  } = useCreatePointMultiplier();

  const {handleDraft: handlePointMultiplierDraft} = usePointMultiplier();

  const handleDraft = async () => {
    try {
      const reqObj = createReqObj('draft');
      const draftResponse = await handlePointMultiplierDraft(reqObj);
      if (!draftResponse?.success) {
        return;
      }
    } catch (error) {
      logger.error('Error saving draft:', error);
      return;
    }
  };

  const handleNext = () => {
    if (
      formData?.uploadOutcome?.totalCount > 0 ||
      formData?.uploadOutcome.nonExistentIds?.length > 0
    ) {
      navigate(ROUTES.POINT_MULTIPLIER_REVIEW);
    }
  };
  return (
    <div className='salesTargetsContainer flex flex-col'>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: ROUTES.HOME,
              label: ''
            },

            {
              href: '',
              label: 'Earn Points'
            }
          ]
        }}
        id={'pm_bradcrumb'}
      />
      <PageHeader title='Create Point Multiplier' />

      <div className='grid p-8 '>
        <div className='w-3/5 justify-self-center'>
          <ProgressIndicator
            currentStep={2}
            completed={false}
            isDark={false}
            // orientation="horizontal"
            steps={3}
            titles={[{title: 'Setup'}, {title: 'Products'}, {title: 'Review'}]}
          />
        </div>
      </div>
      <PageContainer>
        {isCancel ? (
          <Modal
            type={MODAL_TYPE.FLUID}
            showModal={isCancel}
            onCloseModal={handleCancel}
            title='Are you sure you want to cancel?'
            text={
              'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'
            }
            showPrimaryButton={true}
            primaryButtonText='Yes'
            onClickPrimaryButton={onClickPrimaryButton}
            showSecondaryButton={true}
            secondaryButtonText='No'
            onClickSecondaryButton={onClickSecondaryButton}
            footerProps={{
              size: 'medium',
              type: 'primary'
            }}
            isDark={true}
          />
        ) : null}
        <ProductsPointMultiplierSection
          formData={formData}
          setFormData={setFormData}
          rulesCriteriaJsonSchema={rulesCriteriaJsonSchema}
          rulesCriteriaUISchema={rulesCriteriaUISchema}
          formError={formError}
          setFormError={setFormError}
          formFields={formFields}
          disableNext={disableNext}
          setDisableNext={setDisableNext}
          handleUpdateValue={handleUpdateValue}
          segmentJsonSchema={segmentJsonSchema}
          categoryJsonSchema={categoryJsonSchema}
          channelJsonSchema={channelJsonSchema}
          handleFormChange={handleFormChange}
        />
      </PageContainer>

      <SaveCancelFooter
        handleCancel={handleCancel}
        nextAction={handleNext}
        draftAction={handleDraft}
        FormError={disableNext}
        hideSaveDraft={false}
      />
    </div>
  );
};
